export const FOLDER_DOCUMENTS = "/api/all-folders/:param/documents"
export const FOLDER_DOCUMENT = "/api/folder/:param/document/:documentParam"
